import { render } from "./SectionConnection.vue?vue&type=template&id=1673e2e6&scoped=true"
import script from "./SectionConnection.vue?vue&type=script&lang=js"
export * from "./SectionConnection.vue?vue&type=script&lang=js"

import "./SectionConnection.vue?vue&type=style&index=0&id=1673e2e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1673e2e6"]])

export default __exports__